import { createSlice, createAsyncThunk }from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import earnPointsApi from "../../services/earnPointsApi";
import { showSuccessSnackbar, showErrorSnackbar } from "./snackbarSlice";
import { fetchUserPointsAndRewards } from "./rewardSlice";
import { POLL_VOTEDFOR } from "../../lib/constants/globalConstant";

export const getBonusPoints= createAsyncThunk("earnPoint/getBonusPoints", async(data, {rejectWithValue, dispatch})=>{
    try{
        const response= await earnPointsApi.getBonusPoints(data);
        if(response.status === 0){
            return response?.data;
        }
        else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});


export const claimBonusPoint= createAsyncThunk("earnPoint/claimBonusPoint", async(data, { rejectWithValue, dispatch })=>{
    try{
        const _dataToPass = {...data};
        if(_dataToPass?.seasonId) {
            delete _dataToPass?.seasonId
        }
        const response= await earnPointsApi.claimBonusPoint(_dataToPass);
        
        if(response.status === 0){
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));
            dispatch(getBonusPoints())
            dispatch(fetchUserPointsAndRewards({ seasonId: data?.seasonId }))
            return response?.data;
        }
        else{
            dispatch(showErrorSnackbar({title: response?.message}));
            return rejectWithValue(response?.message);
        }
    }catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({title: error?.meesage}));
        return rejectWithValue(error.message);
    }
});

// export const claimAllBonusPoints= createAsyncThunk("earnPoint/claimAllBonusPoints", async(data,{rejectWithValue, dispatch})=>{
//     try{
//         const response= await earnPointsApi.claimAllBonusPoints(data);
//         if(response.status === 0){
//             return (response?.data);
//         }
//         else{
//             dispatch(showErrorSnackbar({title: response?.message}));
//             return rejectWithValue(response?.message);
//         }
//     }catch(error){
//         console.log(error);
//         dispatch(showErrorSnackbar({title: error?.meesage}));
//         return rejectWithValue(error.message);
//     }
// });

export const getCurrentPolls= createAsyncThunk("earnPoint/getCurrentPolls", async(data, {rejectWithValue, dispatch})=>{
    try{
        const response= await earnPointsApi.getCurrentPolls(data);
        if(response.status ===0){
            // dispatch(showSuccessSnackbar({title: response?.data?.message}));
            return response?.data?.polls;
        }
        else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

export const submitPollAnswer = createAsyncThunk("earnPoint/submitPollAnswer", async({ data, userId, showSnackbarOnBottom, isLivePoll }, {rejectWithValue, dispatch})=>{
    try{
        const response= await earnPointsApi.submitPollAnswer(data);
        if(response.status === 0){
            const successMessage = showSnackbarOnBottom
                ? { title: response?.data?.message, position: { vertical: "bottom", horizontal: "left"} }
                : { title: response?.data?.message };

            if(response?.data?.success === -1) {
                dispatch(showErrorSnackbar(successMessage));

                dispatch(updatePollsStateOnSubmitForAlreadySubmitted({
                    pollId: data?.pollId,
                    poll: response?.data?.poll
                }));
            }else {
                dispatch(showSuccessSnackbar(successMessage));

                // Dispatch the poll update with necessary details
                dispatch(updatePollDetailsOnSubmit({
                  pollId: data?.pollId,
                  selectedOptionId: data?.answers[0]?._id,
                  userId: userId, // Add this to your submission data,
                  isLivePoll,
                  votedFor: data?.votedFor,
                  gameId: data?.gameId,
                }));
            }

            return response?.data;
        }
        else{
            const errorMessage = showSnackbarOnBottom
                ? { title: response?.message, position: { vertical: "bottom", horizontal: "left"} }
                : { title: response?.message };
            dispatch(showErrorSnackbar(errorMessage));
            return rejectWithValue(response?.message);
        }
    }catch(error){
        console.log(error);
        const errorMessage = showSnackbarOnBottom
          ? { title: error?.message, position: { vertical: "bottom", horizontal: "left"} }
          : { title: error?.message };
        dispatch(showErrorSnackbar(errorMessage));
        return rejectWithValue(error.message);
    }
});

export const getPreviousPolls= createAsyncThunk("earnPoint/getPreviousPolls", async(data, {rejectWithValue, dispatch})=>{
    try{
        const response= await earnPointsApi.getPreviousPolls(data);
        if(response.status === 0){
            // dispatch(showSuccessSnackbar({title: response?.data?.message}));
            return response?.data?.polls;
        }
        else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

export const getLivePolls= createAsyncThunk("earnPoint/getLivePolls", async(data, {rejectWithValue, dispatch})=>{
    try{
        const response= await earnPointsApi.getLivePolls(data);
        if(response.status === 0){
            // dispatch(showSuccessSnackbar({title: response?.data?.message}));
            return response?.data?.polls;
        }
        else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

const earnPointSlice= createSlice({
    name : "earnPoint",
    initialState : {
        bonusPoints: [],
        currentPolls: [],
        livePolls: [],
        isLoading: false,
        error: null,
        bonusPointsLoading: true,
        claimingBonusPoint: false,
    },
    reducers: {
        updatePollDetailsOnSubmit: (state, action) =>  {
            const { pollId, selectedOptionId, userId, votedFor, gameId } = action.payload;            
            const polls = [...state.currentPolls];
            
            // Update current polls
            const updatedPolls = polls?.map(poll => {
                if(!poll || poll?._id !== pollId) return poll;

                // Increment total votes
                const updatedPoll = {
                    ...poll,
                    totalVotesDetail: poll?.totalVotesDetail || [],
                    selectedOptionId
                };

                // Helper function to update totalVotesDetail
                const updateVoteDetail = (votedFor, gameId) => {
                    const index = updatedPoll.totalVotesDetail.findIndex(vote => 
                        vote.votedFor === votedFor && (votedFor !== POLL_VOTEDFOR.GAME || vote.gameId === gameId)
                    );

                    if (index > -1) {
                        updatedPoll.totalVotesDetail[index].totalVotes += 1;
                    } else {
                        updatedPoll.totalVotesDetail.push({ votedFor, totalVotes: 1, gameId });
                    }
                };

                updateVoteDetail(votedFor, gameId);

                // if(votedFor === POLL_VOTEDFOR.SEASON) {
                //     const _recordIndex = updatedPoll?.totalVotesDetail?.findIndex(vote => vote?.votedFor === POLL_VOTEDFOR.SEASON);
                //     if(_recordIndex > -1) {
                //         updatedPoll.totalVotesDetail[_recordIndex] = {
                //             ...updatedPoll?.totalVotesDetail?.[_recordIndex],
                //             totalVotes: (updatedPoll?.totalVotesDetail?.[_recordIndex]?.totalVotes || 0) + 1
                //         }
                //     }else {
                //         updatedPoll?.totalVotesDetail?.push({
                //             votedFor: POLL_VOTEDFOR.SEASON,
                //             totalVotes: 1,
                //             gameId: null
                //         });
                //     }
                // }else if(votedFor === POLL_VOTEDFOR.GAME) {
                //     const _recordIndex = updatedPoll?.totalVotesDetail?.findIndex(vote => (vote?.votedFor === POLL_VOTEDFOR.GAME && vote?.gameId === gameId));
                //     if(_recordIndex > -1) {
                //         updatedPoll.totalVotesDetail[_recordIndex] = {
                //             ...updatedPoll?.totalVotesDetail?.[_recordIndex],
                //             totalVotes: (updatedPoll?.totalVotesDetail?.[_recordIndex]?.totalVotes || 0) + 1
                //         }
                //     }else {
                //         updatedPoll?.totalVotesDetail?.push({
                //             votedFor: POLL_VOTEDFOR.GAME,
                //             totalVotes: 1,
                //             gameId: gameId
                //         });
                //     }
                // }

                // Update poll options
                const updatedPollOptions = poll.pollOptions.map(option => {
                    if(!option || option?._id !== selectedOptionId) return option;

                    // const _voteDetailInd = option?.voteDetails?.findIndex(vote => (vote?.votedFor === votedFor) && (votedFor === POLL_VOTEDFOR.SEASON || (votedFor === POLL_VOTEDFOR.GAME && vote.gameId === gameId)));
                    const _voteDetailInd = option.voteDetails?.findIndex(vote =>
                        vote.votedFor === votedFor && (votedFor !== POLL_VOTEDFOR.GAME || vote.gameId === gameId)
                    );
                    
                    if(_voteDetailInd > -1) {
                        const _vote = option?.voteDetails?.[_voteDetailInd];
                        if(!_vote) return;

                        if(_vote?.userIds && _vote?.userIds?.length) {
                            _vote?.userIds?.push(userId);
                        }else {
                            _vote.userIds = [userId];
                        }

                        option.voteDetails[_voteDetailInd] = _vote;
                    }else {
                        let _vote = null;
                        if(votedFor === POLL_VOTEDFOR.SEASON) {
                            _vote = {
                                votedFor: POLL_VOTEDFOR.SEASON,
                                userIds: [userId],
                                gameId: null
                            }
                        }else {
                            _vote = {
                                votedFor: POLL_VOTEDFOR.GAME,
                                userIds: [userId],
                                gameId: gameId
                            }
                        }

                        if(!_vote) return;

                        if(!option?.voteDetails) option.voteDetails = [];
                        option?.voteDetails?.push(_vote);
                    }

                    return {
                        ...option,
                        votes: (option?.votes || 0) + 1
                    };
                });

                return {
                    ...updatedPoll,
                    pollOptions: updatedPollOptions
                };
            });

            // Update live polls similarly if needed
            // const updatedLivePolls = state.livePolls.map(poll => {
            //     if (poll._id === pollId) {
            //         // Similar update logic as current polls
            //         const updatedPoll = {
            //             ...poll,
            //             totalVotes: (poll.totalVotes || 0) + 1,
            //             selectedOptionId: selectedOptionId
            //         };

            //         const updatedPollOptions = poll.pollOptions.map(option => {
            //             if (option._id === selectedOptionId) {
            //                 return {
            //                     ...option,
            //                     votes: (option.votes || 0) + 1,
            //                     votedBy: [...(option.votedBy || []), userId]
            //                 };
            //             }
            //             return option;
            //         });

            //         return {
            //             ...updatedPoll,
            //             pollOptions: updatedPollOptions
            //         };
            //     }
            //     return poll;
            // });

            // Update state
            // if(isLivePoll){
            //     state.livePolls = updatedPolls;
            // } else {
            // }
            state.currentPolls = updatedPolls;
            // state.livePolls = updatedLivePolls;
        },
        updateLivePollsStateOnSubmit: (state, action) => {
            const { pollId, update } = action.payload;
            const savedPolls = state.livePolls

            if(!savedPolls || savedPolls?.length === 0){
                return;
            }

            const pollIndex = savedPolls?.findIndex(poll => poll?._id === pollId);
            if (pollIndex === -1) return; // Poll not found

            // Clone the state immutably
            const updatedPolls = [...savedPolls];
            // const poll = { ...updatedPolls[pollIndex], pollOptions: [...updatedPolls[pollIndex].pollOptions]}
            const poll = { 
                ...updatedPolls[pollIndex], 
                pollOptions: updatedPolls[pollIndex].pollOptions ? [...updatedPolls[pollIndex].pollOptions] : [] 
            };

            Object.entries(update).forEach(([key, value]) => {
                if (key === "pollOptions") {
                    if (!Array.isArray(poll.pollOptions)) return;
        
                    Object.entries(value).forEach(([optionIndex, optionUpdate]) => {
                        if (!poll.pollOptions[optionIndex]) {
                            poll.pollOptions[optionIndex] = optionUpdate;
                            return;
                        };
                        let option = poll.pollOptions[optionIndex];

                        Object.entries(optionUpdate).forEach(([key, value]) => {
                            if(key === "voteDetails") {                                
                                if (Array.isArray(optionUpdate.voteDetails)) {
                                    // Case 1: If voteDetails is received as a full updated array
                                    option.voteDetails = optionUpdate.voteDetails;
                                } else if (typeof optionUpdate.voteDetails === "object") {
                                    Object.entries(optionUpdate.voteDetails).forEach(([voteDetailIndex, voteDetail]) => {
                                        if (!Array.isArray(option.voteDetails)) {
                                            option.voteDetails = [];
                                        }
                                        let existingDetail = option.voteDetails.find((vd, idx) => idx == Number(voteDetailIndex));

                                        if (!existingDetail) {
                                            // Push a new vote detail if it doesn't exist
                                            option.voteDetails.push(voteDetail);
                                        } else {
                                            Object.entries(voteDetail).forEach(([voteDetailKey, voteDetailValue]) => {
                                                if(voteDetailKey === "userIds") {
                                                    if(typeof voteDetailValue === "object" && !Array.isArray(voteDetailValue)) {
                                                        // Convert object to array
                                                        voteDetailValue = Object.values(voteDetailValue);
                                                    }

                                                    // Merge userIds array
                                                    existingDetail.userIds = [...new Set([...(existingDetail.userIds || []), ...voteDetailValue])];
                                                }else {
                                                    existingDetail[voteDetailKey] = voteDetailValue;
                                                }
                                            })
                                        }
                                    })
                                }
                            }else {
                                poll.pollOptions[optionIndex][key] = value;
                            }
                        })
                    });

                    poll.pollOptions = poll.pollOptions.reduce((uniqueOptions, option) => {
                        if (!uniqueOptions.some(o => o._id === option._id)) {
                            uniqueOptions.push(option);
                        }
                        return uniqueOptions;
                    }, []);

                    if(Array.isArray(value)) {
                        poll.pollOptions = poll.pollOptions.filter(option =>
                            Object.values(value).some(updatedOption => updatedOption._id === option._id)
                        );
                    }
        
                } else {
                    // Update other fields directly
                    poll[key] = value;
                }
            });

            updatedPolls[pollIndex] = poll;

            // Update the state
            state.livePolls = updatedPolls;
        },
        deleteOldLivePoll: (state, action) => {
            const { pollId } = action.payload;
            const savedPolls = state.livePolls

            if(!savedPolls || savedPolls?.length === 0){
                return;
            }
            
            state.livePolls = savedPolls?.filter(poll => poll?._id !== pollId) || [];
        },
        createNewLivePoll: (state, action) => {
            const { poll } = action.payload;
            if(!poll || !poll?._id) return;
            
            // Ensure state.livePolls exists
            if (!state.livePolls) {
                state.livePolls = [];
            }
            
            // Check if poll already exists
            const pollExists = state.livePolls.some(existingPoll => existingPoll._id === poll._id);
            if (pollExists) return;

            // Add the new poll at the beginning
            state.livePolls.unshift(poll);
        },
        addNewUpdatedPoll: (state, action) => {
            const { poll } = action.payload;
            if(!poll || !poll?._id) return;
            
            // Ensure state.livePolls exists
            if (!state.livePolls) {
                state.livePolls = [];
            }
            
            // Check if poll already exists
            const pollExists = state.livePolls.some(existingPoll => existingPoll._id === poll._id);
            if (pollExists) return;

            // Add the new poll at the beginning
            state.livePolls.unshift(poll);
        },
        updateLivePollGameIds: (state, action) => {
            const { poll, pollId, currentGameId, userId } = action.payload;
            if(!poll || !poll?._id) return;
            // Ensure state.livePolls exists
            if (!state.livePolls) {
                state.livePolls = [];
            }

            let savedPolls = [...state.livePolls];
            // Ensure state.livePolls exists
            if(!savedPolls || savedPolls?.length === 0){
                return;
            }

            // Check if poll already exists
            const pollIndex = savedPolls?.findIndex(poll => poll?._id === pollId);
            const _isCurrentGamePresent = poll?.gameId?.some(gameId => gameId === currentGameId);

            if(pollIndex === -1 && _isCurrentGamePresent) {
                // Poll not found
                // check if user has already participated
                const _isUserHasVoted = poll?.pollOptions?.some((option) => 
                    option?.votedBy?.find((voter) => voter === userId)
                );

                if(_isUserHasVoted) {
                    savedPolls.push(poll);
                }else {
                    savedPolls.unshift(poll);
                }
            } else if(pollIndex !== -1) {
                if(_isCurrentGamePresent) {
                    const _poll = { ...savedPolls[pollIndex], pollOptions: [...savedPolls[pollIndex].pollOptions], gameId: [...(poll?.gameId || [])]}

                    savedPolls[pollIndex] = _poll;
                }else {
                    savedPolls = savedPolls?.filter(poll => poll?._id !== pollId) || [];
                }
            }

            // Add the new poll at the beginning
            state.livePolls = savedPolls;
        },
        updateTotalLivePollsStateOnSubmit: (state, action) => {
            const { pollId, totalVotesDetail } = action.payload;

            if (!state?.livePolls || state?.livePolls?.length === 0) {
                return;
            }

            // Find the relevant poll by ID
            const pollIndex = state?.livePolls?.findIndex(poll => poll?._id === pollId);
            if (pollIndex === -1) return; // Poll not found

            // Clone the specific poll and update the totalVotes field
            const updatedPolls = [...state.livePolls];
            const poll = { 
                ...updatedPolls[pollIndex], 
                totalVotesDetail: updatedPolls[pollIndex]?.totalVotesDetail 
                    ? [...updatedPolls[pollIndex].totalVotesDetail] 
                    : [] // Ensure it's always an array
            };

            if(Array.isArray(totalVotesDetail)) {
                poll.totalVotesDetail = [...totalVotesDetail];
            }else if(typeof totalVotesDetail === 'object' && totalVotesDetail) {
                Object.entries(totalVotesDetail).forEach(([voteIndex, voteUpdate]) => {
                    if(voteIndex === "totalVotesDetail") {
                        if(Array.isArray(voteUpdate)) {
                            poll.totalVotesDetail = [...voteUpdate];
                        }else if(typeof voteUpdate === 'object') {
                            Object.entries(voteUpdate).forEach(([subVoteIndex, subVoteUpdate]) => {
                                let existingVote = poll.totalVotesDetail.find((vd, idx) => idx == subVoteIndex);
                                if (!existingVote) {
                                    // If the index doesn't exist, add new entry
                                    poll.totalVotesDetail.push({ ...subVoteUpdate });
                                } else {
                                    // Merge existing fields
                                    Object.entries(subVoteUpdate).forEach(([key, value]) => {
                                        existingVote[key] = value;
                                    });
                                }
                            })
                        }
                    }else {
                        poll.totalVotesDetail[voteIndex] = voteUpdate;
                    }
                });
            }


            // Replace the updated poll in the list of polls
            updatedPolls[pollIndex] = poll;            

            // Update the state
            state.livePolls = updatedPolls;
        },
        updatePollsStateOnSubmitForAlreadySubmitted: (state, action) => {
            const { poll } = action.payload;

            if (!state?.currentPolls || state?.currentPolls?.length === 0 || !poll) {
                return;
            }

            // Find the relevant poll by ID
            const pollIndex = state?.currentPolls?.findIndex(_poll => _poll?._id === poll?._id);
            if (pollIndex === -1) return; // Poll not found

            // Clone the specific poll and update the totalVotes field
            const updatedPolls = [...state.currentPolls];

            // Replace the updated poll in the list of polls
            updatedPolls[pollIndex] = poll;

            // Update the state
            state.currentPolls = updatedPolls;
        },
    },
    extraReducers: (builder) => {
        handleAsyncThunk(builder, getBonusPoints, "bonusPoints", "error", "bonusPointsLoading");
        handleAsyncThunk(builder, claimBonusPoint, "claimBonusPoint", "error", "claimingBonusPoint");
        // handleAsyncThunk(builder, claimAllBonusPoints, "claimAllBonusPoints", "error", "claimingAllBonusPoints");
        handleAsyncThunk(builder, getCurrentPolls, "currentPolls", "error", "isCurrentPollsLoading");
        handleAsyncThunk(builder, submitPollAnswer, "pollAnswer", "error", "isSubmitting");
        handleAsyncThunk(builder, getPreviousPolls, "previousPolls", "error", "isPreviousPollsLoading");
        handleAsyncThunk(builder, getLivePolls, "livePolls", "error", "isLivePollsLoading");
    },
});

export const { updatePollDetailsOnSubmit, updateLivePollsStateOnSubmit, createNewLivePoll, addNewUpdatedPoll, updateLivePollGameIds, deleteOldLivePoll, updateTotalLivePollsStateOnSubmit, updatePollsStateOnSubmitForAlreadySubmitted } = earnPointSlice.actions;

export default earnPointSlice.reducer;